export const LOAD_BUTTON_TEXT = `Пожалуйста, подождите…`;
